// Third party components
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

// MUI components
import {Card, CardContent, Container, Grid, Typography} from '@mui/material';

// Storybook components
import { LineLoader, LoadingSpinner, SubHeader} from '@timmons-group/shared-react-components';

import UnitDetails from '../features/Unit/UnitDetails';
import PracticesAndActivitiesCard from '../features/Unit/PracticesAndActivitiesCard';

// Hooks
import { useUnit, ACTIONS } from '../hooks/useUnit';

const ViewUnit = () => {
  let { id } = useParams();
  const bigStore = useUnit();
  const { unitState, unmount, dispatch } = bigStore;
  const { unit, modifying, loading } = unitState;

  // This effect will also fire if the id changes in the url
  useEffect(() => {
    if(id) {
      dispatch({type: ACTIONS.SET_ID, payload: id});
    }

    // Unmount on cleanup to reset the state
    return () => {
      unmount();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (loading) {
    return (
      <Container>
        <Card>
          <CardContent>
            <LineLoader message="Loading..." color="secondary" />
          </CardContent>
        </Card>
      </Container>
    );
  }
  else if (!loading && (!unit || unitState?.error)) {
    return (
      <Container>
        <Card>
          <CardContent>
            <Typography sx={{textAlign: 'center'}} variant="panelHeader">{unitState?.error || 'Unit not found'}</Typography>
          </CardContent>
        </Card>
      </Container>
    );
  }

  return (
    <>
      <SubHeader
        title={ unit.unitName }
        sx={{ fontSize: '1.25 rem'}}
      />
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <UnitDetails unit={unit} />
          <PracticesAndActivitiesCard
            practices={ unit.practices }
            activities={ unit.activities }
            loading={loading}
          />
        </Grid>
      </Grid>
      <LoadingSpinner isActive={modifying} />
    </>
  );
};

export default ViewUnit;
